import { BANKID_AUTHENTICATE, BANKID_COLLECT } from '../Actions/BankId.action';

const defaultState = {
    personNumber: ""
}
export const bankId = (state = defaultState, action) => {
    switch (action.type) {
        case BANKID_AUTHENTICATE:
        case BANKID_COLLECT:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}